import React, {useCallback, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaEraser, FaList} from "react-icons/fa";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {FaFilePen} from "react-icons/fa6";

const FormList = ({templates, handleModule, canCreateNewForms}) => {
    const [name, setName] = useState("")

    const gridRef = useRef(undefined)

    const [columnDefs,] = useState([
        {headerName: "Nome", field: "name", flex: 1, comparator: aggridUtils.nullLastComparator},
        {
            headerName: "",
            field: "",
            cellRenderer: ({node: {data}, handleModule}) => (
                <div className="flex flex-row items-center justify-self-center h-full gap-2">
                    <Button title={"Lista de formulários preenchidos"} onClick={() => handleModule("submissions", data.id)}>
                        <FaList />
                    </Button>

                    {
                        canCreateNewForms &&
                        <Button title={"Preencher"} onClick={() => handleModule("fill", data.id)}>
                            <i className="fa-solid fa-file-pen"></i>
                            <FaFilePen />
                        </Button>
                    }
                </div>
            ),
            cellRendererParams: {handleModule, canCreateNewForms},
            width: 135
        }
    ])

    const defaultColDef = useMemo(() => ({resizable: false}), [])

    const handleFilter = useCallback((value) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            value,
        )

        setName(value)
    }, [])

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    return (
        <>
            <div className="flex justify-between gap-4">
                <InputForm
                    id="name"
                    type="text"
                    label="Nome"
                    value={name}
                    onChange={({target: {value}}) => handleFilter(value)}
                    classNameWrapper="w-[calc(100%-60px)]"
                />

                <div className="buttons">
                    <Button className={"h-[25px]"} title="Limpar" onClick={() => handleFilter("")}>
                        <FaEraser />
                    </Button>
                </div>
            </div>

            <div className={`aggrid-row-pointer mt-2`} style={{height: "calc(100vh - 265px)"}}>
                <AgGridReact
                    ref={gridRef}
                    rowHeight={40}
                    rowData={templates ?? []}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressCellFocus={true}
                    pagination
                    gridOptions={{localeText: aggridUtils.generalTheme()}}
                    theme={theme}
                />
            </div>
        </>
    );
};

export default FormList;